// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c6050e4d","453":"c71d9680","667":"c09e4001","977":"87cfbd39"}[chunkId] + ".chunk.js";
};